import React, { useEffect, useState } from 'react';
import './UserDetails.css';
import { SideMenuBar } from '../../SideMenu';
import { NewHeader } from '../../NewHeader';
import { useLocation, useNavigate } from 'react-router-dom';
import { API_URL } from '../../Config';
import axios from 'axios';


const UsersDetails = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const userDetails = location.state?.userDetails || null;

  const [formData, setFormData] = useState({

    username: userDetails.username || '',
    mobile: userDetails.mobile || '',
    email: userDetails.email || '',
    role: userDetails.role || '',
    address: userDetails.address || '',
    date_of_birth: userDetails.date_of_birth || '',
    blood_group: userDetails.blood_group || '',
    id_proof: userDetails.id_proof || '',
    id_proof_number: userDetails.id_proof_number || '',
    work_type: userDetails.work_type || '',
    previous_work: userDetails.previous_work || '',
    previous_work_with: userDetails.previous_work_with || '',
    reference_name: userDetails.reference_name || '',
    password: userDetails.password || '',
    confirm_password: userDetails.confirm_password || '',
    total_task_count: userDetails.total_task_count || '',
    total_distance_count: userDetails.total_distance_count || '',
    total_present_days_count: userDetails.total_present_days_count || '',
    total_absent_days_count: userDetails.total_absent_days_count || '',
    uuId: userDetails.uuId || '',
    manager: userDetails.manager || '',
    punch_In: userDetails.punch_In || '',
    punch_out: userDetails.punch_out || '',
    total_hour: userDetails.total_hour || '',
    profile: userDetails.profile || '',
    date_of_join: userDetails.date_of_join || '',
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const [users, setUsers] = useState([]);
  useEffect(() => {
    fetch(API_URL + '/users')
      .then(response => response.json())
      .then(data => setUsers(data))
      .catch(error => console.error(error));
  }, []);

  let work_type_data;
  let role_data;
  let manager_data;
  if(users && users.length > 0) {
    work_type_data = users.map(user => user.work_type).filter((value, index, self) => self.indexOf(value) === index);
    role_data = users.map(user => user.role).filter((value, index, self) => self.indexOf(value) === index);
    manager_data = users.map(user => user.manager).filter((value, index, self) => self.indexOf(value) === index);
  }

  const updateTask = async () => {
    try {
      const response = await axios.put(API_URL + `/user/${userDetails.username}`, formData);

      if (response.status === 200) {
        console.log('User updated successfully');
        window.alert('User updated successfully!')
        navigate('/EmployeeDatabase')
      } else {
        console.error('Error updating user');
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div>
      <SideMenuBar></SideMenuBar>

      <div class="content">
        <NewHeader></NewHeader>

        <div className='row2'>
          <h3 className='users'>Users</h3>
        </div>

        <div class="container_UserDetails">
          <div class="main_column1_UserDetails" >

            <h4 className='h4_heading_column1_UserDetails'>Personal Info</h4>

            <p className='title_column1_UserDetails'>Full Name</p>
            <input className='input_column1_UserDeatils' placeholder='Full Name' name='username'
              value={formData.username}
              onChange={handleInputChange}></input>

            <p className='title_column1_UserDetails'>Phone No.</p>
            <input className='input_column1_UserDeatils' placeholder='Phone No.' name='mobile'
              value={formData.mobile}
              onChange={handleInputChange}></input>

            <p className='title_column1_UserDetails'>Email ID</p>
            <input className='input_column1_UserDeatils' placeholder='Email ID' name='email'
              value={formData.email}
              onChange={handleInputChange}></input>

            <p className='title_column1_UserDetails'>Blood Group</p>
            <input className='input_column1_UserDeatils' placeholder='Blood Group' name='blood_group'
              value={formData.blood_group}
              onChange={handleInputChange}></input>

            <p className='title_column1_UserDetails'>Current Address</p>
            <textarea className='textarea_column1_UserDeatils' placeholder='Current Address' name='address'
              value={formData.address}
              onChange={handleInputChange}></textarea>

            <p className='title_column1_UserDetails'>Permanent Address</p>
            <textarea className='textarea_column1_UserDeatils' placeholder='Permanent Address'></textarea>

            <p className='title_column1_UserDetails'>Identity Proof</p>
            <input className='input_column1_UserDeatils' placeholder='Identity Type' name='id_proof_number'
              value={formData.id_proof_number}
              onChange={handleInputChange}></input><br /><br />
            <a className='a_of_uploadHere_UserDetails' href='/'><img className='cloud_upload_img' src='../assets/cloud_upload.png' alt='cloud_upload-icon'></img>&nbsp;<span className='uploadHere_UserDetails'><i>Upload Here(.jpg / .png)</i></span></a><br />

          </div>

          <div class="main_column2_UserDetails" >
            <h4 className='h4_heading_column2_UserDetails'>Work Info</h4>

            <p className='title_column2_UserDetails'>Work Type</p>
            <select className='select_Userdetails' name='work_type'
              value={formData.work_type}
              onChange={handleInputChange}>
              <option value="" disabled hidden>Select</option>
              {work_type_data && work_type_data.map((workType, index) => (
                <option key={index} value={workType} className='options'>
                  {workType}
                </option>
              ))}
            </select>

            <p className='title_column2_UserDetails'>Role</p>
            <select className='select_Userdetails' name='role'
              value={formData.role}
              onChange={handleInputChange}>
              <option value="" disabled hidden>Select</option>
              {role_data && role_data.map((role, index) => (
                <option key={index} value={role} className='options'>
                  {role}
                </option>
              ))}
            </select>

            <p className='title_column2_UserDetails'>Manager</p>
            <select className='select_Userdetails' name='manager'
              value={formData.manager}
              onChange={handleInputChange}>
              <option value="" disabled hidden>Select</option>
              {manager_data && manager_data.map((manager, index) => (
                <option key={index} value={manager} className='options'>
                  {manager}
                </option>
              ))}
            </select>

            <p className='title_column2_UserDetails'>User ID</p>
            <input className='input_column2_UserDeatils' placeholder='User ID' name='uuId'
              value={formData.uuId}
              onChange={handleInputChange}></input>

            <p className='title_column2_UserDetails'>Password</p>
            <input className='input_column2_UserDeatils' placeholder='Enter Password' name='password'
              value={formData.password}
              onChange={handleInputChange}></input><br /><br />
            <input className='input_column2_UserDeatils' placeholder='Confirm Password' name='confirm_password'
              value={formData.confirm_password}
              onChange={handleInputChange}></input>

            <p className='view_current_location_UserDetails'><a href='/'> <b> Click Here to View Current Location</b></a></p>
          </div>
        </div>

        <div className='row9_UserDetails'>
          <h3 className='others_UserDetails' >Others</h3>
        </div>


        <div class="row10_UserDetails">
          <div class="column1_row10">
            <p className='title_column1_row10_UserDetails'>Total Tasks (Monthly)</p>
            <div className='column1_sub_row10_UserDetails'><label>{userDetails.total_task_count}</label></div>
            <p className='title_column1_row10_UserDetails'>Total Days Absent (Monthly)</p>
            <div className='column1_sub_row10_UserDetails'><label>{userDetails.total_absent_days_count}</label></div>
          </div>

          <div class="column2_row10">
            <p className='title_column2_row10_UserDetails'>Total Distance (Monthly)</p>
            <div className='column2_sub_row10_UserDetails'><label>{userDetails.total_distance_count}</label></div>
            <p className='title_column2_row10_UserDetails'>Total Hours Worked (Monthly)</p>
            <div className='column2_sub_row10_UserDetails'><label>{userDetails.total_hour}</label></div>
          </div>

          <div class="column3_row10">
            <p className='title_column3_row10_UserDetails'>Total Days Present (Monthly)</p>
            <div className='column3_sub_row10_UserDetails'><label>{userDetails.total_present_days_count}</label></div>
          </div>
        </div>

        <button className='update_btn_input_UserDetails' onClick={updateTask}>Update</button>
        <br /><br />

        <br />
      </div>

    </div>
  )
}

export default UsersDetails;